/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import Spinner from '@atlaskit/spinner/spinner'` instead.
 */
export { default } from './spinner';
/**
 * @deprecated Use `import type { Size, Appearance, SpinnerProps } from '@atlaskit/spinner/types'` instead.
 */
export type { Size, Appearance, SpinnerProps } from './types';
